// test2756
(2756 && 0);
